import React, { useState, useMemo } from "react";
import AppLineCard from './AppLineCard';
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AppListTagArray from './AppListTagArray';
import translate from '../../other/translate.json'

const AllAppsTile = (props) => {
	const [language, setLanguage] = useState(localStorage.getItem('language') || 'Ru')
	let IsRu = language === 'Ru'

	const handleDelete = (chipToDelete) => () => {
		setArrayTag(props.arrayTag.filter((chip) => chip.key !== chipToDelete.key));
	};
	let { isProd, paginator, cardArr, type, notDeleteFromBasketArr, notDeleteFromBasketArrCloud, setAppBasketA, basket, cart, setAppBasket, checkAll, setCheckAll, arrayTag, setArrayTag, page } = props
	const RenderArr = () => (
		cardArr && cardArr.length > 0
			?
			cardArr.map((el, i) =>
			(
				<Grid container style={{ width: '100%' }} key={'AppLineCard' + el.ID} >
					<AppLineCard
						isProd={isProd}
						checkAll={checkAll}
						setCheckAll={setCheckAll}
						setAppBasket={setAppBasket}
						setAppBasketA={setAppBasketA}
						notDeleteFromBasketArrCloud={notDeleteFromBasketArrCloud}
						notDeleteFromBasketArr={notDeleteFromBasketArr}
						lang={language}
						type={type}
						readLink={el.isHideAppLink === 1 || el.systemid === 34}
						key={el.CodeAsvul}
						data={el}
						IsRu={IsRu}
						basket={basket}
						cart={cart}
						setArrayTag={setArrayTag}
						arrayTag={arrayTag}
						addTagtoArray={setArrayTag}
						upPriority={props.upPriority}
						usname={props.usname}
						disablePriorityBtn={props.disablePriorityBtn}
						kloStatuses={props.kloStatuses}
						kloUser={props.kloUser}
						loadingKloStatuses={props.loadingKloStatuses}
						userCollection={props.userCollection}
						saveCollection={props.saveCollection}
						updateArr={props.updateArr}
						alternatives={props.appAlternatives}
					/>
				</Grid>
			))
			:
			null
	)


	return (
		<React.Fragment>
			<Grid item container
			// style={{ marginTop: props.mt ? props.mt : 10 }}
			>
				<Grid
					container
					direction="row"
					justify="space-between"
					alignItems="center"
				>
					{
						window.location.pathname.indexOf("/applications/apptags") > -1
							?
							<AppListTagArray
								arrayTag={arrayTag}
								setArrayTag={handleDelete}
								clearChips={() => props.clearChips()}
							/>
							:
							<Grid container style={{ height: 12 }}></Grid>
					}

					{RenderArr()}
				</Grid>
			</Grid>
		</React.Fragment>
	)
}


const useStyles = makeStyles(theme => ({
	// root: {
	// 	display: "flex"
	// },

	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},

	content: {
		flexGrow: 1,
		padding: 0,
		paddingTop: theme.spacing(3),
		marginTop: theme.spacing(12),
		// backgroundColor: 'inherit'
	},

	contentOpen: {
		width: `calc(100% - 668px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
	},

	contentClose: {
		width: `calc(100% - 218px)`,

		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),

		[theme.breakpoints.down(1366)]: {
			width: '100%'
		}
	},

	container: {
		margin: '72px auto 0',
		'&:first-child': {
			margin: '0 auto'
		},
		[theme.breakpoints.down(696)]: {
			maxWidth: 'calc(336px * 1)',
		},
		[theme.breakpoints.between(696, 1030)]: {
			maxWidth: 'calc(336px * 2)',
		},
		[theme.breakpoints.between(1030, 1366)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.between(1366, 1702)]: {
			maxWidth: 'calc(336px * 3)',
		},
		[theme.breakpoints.up(1702)]: {
			maxWidth: 'calc(336px * 4)',
		}
	},

	containerImage: {
		[theme.breakpoints.down(1702)]: {
			minWidth: '100%',
		},
	},

	containerInfo: {
		[theme.breakpoints.down(1702)]: {
			display: 'none',
		},
	},

	listItem: {
		padding: theme.spacing(1, 1)
	},

	listItemText: {
		padding: theme.spacing(1, 1)
	},

	paper: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.text.secondary,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2)
	},

	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},

	imgCntr: {
		margin: 'auto',
		display: 'block',
		maxWidth: '100%',
		maxHeight: '100%',
		backgroundImage: 'url(./images/BannerDesctop.png)',
		borderRadius: 24
	},

	footer: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		padding: '36px 0'
	},

	btnFilter: {
		backgroundColor: '#FFF',
		borderRadius: '16px',
		'&:focus': {
			borderRadius: '16px'
		}
	},

	tHeader: {
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		fontWeight: 400
	},

	backToList: {
		fontSize: '12px',
		lineHeight: '14px',
		color: '#8987A2'
	},

	search: {
		position: 'relative',
		borderRadius: 24,
		backgroundColor: 'transparent',
		marginLeft: 0,
		marginRight: theme.spacing(1),
		width: 'auto',
		height: 48,

		[theme.breakpoints.down(1366)]: {
			backgroundColor: 'transparent'
		}
	},

	searchIcon: {
		padding: theme.spacing(0, 2),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: '#8987A2',
		paddingLeft: 0,
		// right: 0
	},

	inputRoot: {
		color: '#8987A2',
	},

	inputInput: {
		padding: theme.spacing(1, 2),
		// vertical padding + font size from searchIcon
		paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
		transition: theme.transitions.create('width'),
		width: 232,
		height: 32,
		[theme.breakpoints.down(1366)]: {
			// width: 0,
			'&:focus': {
				width: 207,
			},
		},
		color: '#8987A2'
	},

	root: {
		flexGrow: 1
	},
	padding: {
		padding: theme.spacing(1)
	},
	demo1: {
		backgroundColor: theme.palette.background.paper
	},
	demo2: {
		backgroundColor: "#2e1534"
	},

	cntrAppCardTop: {
		padding: '36px 0'
	},

	cntrChangeView: {
		marginRight: 23,

		[theme.breakpoints.down(1366)]: {
			display: 'none'
		}
	}
}));

export default AllAppsTile;